var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4111_1814)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.9999 9.33333C10.8953 9.33333 9.99992 8.4379 9.99992 7.33333C9.99992 6.22876 10.8953 5.33333 11.9999 5.33333C13.1045 5.33333 13.9999 6.22876 13.9999 7.33333C13.9999 8.4379 13.1045 9.33333 11.9999 9.33333ZM5.99992 7.33333C4.52716 7.33333 3.33325 6.13943 3.33325 4.66667C3.33325 3.19391 4.52716 2 5.99992 2C7.47268 2 8.66659 3.19391 8.66659 4.66667C8.66659 6.13943 7.47268 7.33333 5.99992 7.33333Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7341 10.0002C14.0051 10.0251 15.8595 11.1733 15.999 13.5998C16.0046 13.6976 15.999 13.9998 15.6373 13.9998H13.0667C13.0667 12.4992 12.5709 11.1144 11.7341 10.0002ZM0.000434456 13.466C0.258839 10.2842 2.84127 8.6665 5.98889 8.6665C9.18081 8.6665 11.8033 10.1953 11.9986 13.4665C12.0064 13.5968 11.9986 13.9998 11.4978 13.9998C9.02742 13.9998 5.35648 13.9998 0.485002 13.9998C0.317808 13.9998 -0.0136412 13.6393 0.000434456 13.466Z",
    fill: "#8D8D8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4111_1814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.e0535911e25953e714419bba7da17d9d.svg";
export { ForwardRef as ReactComponent };